// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltip-wrapper":"opww-","display-arrow":"caKkd","enable-overlay":"Av8LH","top":"_5W3CU","overlay-design":"AQeny","tooltip-content":"TjHvO"};